import { useSearchParams } from 'react-router';
import { DataLoader } from '@/components/ui/DataLoader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { InformationAsOfLabel } from '@/portal/shared/components';
import { CarryDocumentsTab } from '../components/CarryDocumentsTab';
import { CarryFundsTab } from '../components/CarryFundsTab';
import { CarryStructureTab } from '../components/CarryStructureTab';
import { useCarryHoldings } from '../hooks/useCarry';
import type { CarryHoldings } from '../services/carryService';

export function PortalCarryPage() {
  const holdingsQuery = useCarryHoldings();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') ?? 'funds';
  const asOf = holdingsQuery.data?.as_of;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">Fund carry</h1>
        <p className="text-muted-foreground mt-1">
          The funds you hold carried interest in
        </p>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={(tab) => setSearchParams({ tab }, { replace: true })}
      >
        <div className="flex flex-wrap items-center justify-between gap-2">
          <TabsList>
            <TabsTrigger value="funds">Funds</TabsTrigger>
            <TabsTrigger value="documents">Documents</TabsTrigger>
            <TabsTrigger value="structure">Structure</TabsTrigger>
          </TabsList>
          {activeTab === 'funds' && <InformationAsOfLabel date={asOf} />}
        </div>

        <TabsContent value="funds" className="mt-6">
          <DataLoader query={holdingsQuery}>
            {(data: CarryHoldings) => <CarryFundsTab data={data} />}
          </DataLoader>
        </TabsContent>

        <TabsContent value="documents">
          <CarryDocumentsTab />
        </TabsContent>

        <TabsContent value="structure" className="mt-6">
          <CarryStructureTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
